<!-- Revised on 2025/10/16 by mnavarro -->
<template>
  <Button v-if="enableClearAllFilters" size="xs" color="danger" :title="$t('key_button_clear_filters')" variant="fill" @click="click()">
    <span>
      <i class="fa-solid fa-filter" aria-hidden="true"></i>
    </span>
  </Button>
</template>

<script>

  import Button from "./Button.vue"

  export default {
    name: "ClearAllFiltersButton",
    components: {
      Button
    },
    props: {
      enableClearAllFilters: {
        type: Boolean,
        default: true
      },
    },
    emits: ['clear-all-filters'],
    methods: {
      click() {
        this.$emit('clear-all-filters');
      }
    }
  };

</script>